import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-JEIROHC2.mjs";
import "./chunk-4KMFLZZN.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
